<template>
  <div class="back">
    <div class="dialog_addnew">
      <div class="dialog_addnew_title">
        <slot name="dialog_addnew_title"/>
        <button @click="$emit('close')" class="btnc">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M26.0597 0H3.94034C1.76761 0 0 1.76761 0 3.94034V26.0597C0 28.2324 1.76761 30 3.94034 30H26.0597C28.2324 30 30 28.2324 30 26.0597V3.94034C30 1.76761 28.2324 0 26.0597 0ZM27.9569 26.0597C27.9569 27.1057 27.1057 27.9569 26.0597 27.9569H3.94034C2.89425 27.9569 2.04314 27.1057 2.04314 26.0597V3.94034C2.04314 2.89425 2.89425 2.04314 3.94034 2.04314H26.0597C27.1057 2.04314 27.9569 2.89425 27.9569 3.94034V26.0597Z" fill="var(--color-pri)"/>
          <path d="M24.6797 5.32011C24.1097 4.75007 23.1859 4.75007 22.6159 5.32011L15.2072 12.7288L7.79816 5.32011C7.22813 4.75007 6.30434 4.75007 5.7343 5.32011C5.16427 5.89014 5.16427 6.81393 5.7343 7.38397L13.1433 14.793L5.7343 22.2017C5.16427 22.7717 5.16427 23.6955 5.7343 24.2656C6.01917 24.5504 6.39278 24.6929 6.76638 24.6929C7.13998 24.6929 7.51329 24.5504 7.79846 24.2656L15.2075 16.8565L22.6165 24.2656C22.9013 24.5504 23.2749 24.6929 23.6485 24.6929C24.0221 24.6929 24.3955 24.5504 24.6806 24.2656C25.2507 23.6955 25.2507 22.7717 24.6806 22.2017L17.271 14.7927L24.68 7.38368C25.2498 6.81393 25.2498 5.88985 24.6797 5.32011Z" fill="var(--color-pri)"/>
          </svg>
        </button>
      </div>
      <div class="dialog_addnew_content" :style="{maxHeight: 'calc(100vh - 275px)'}">
        <div>
          <svg width="55" height="70" viewBox="0 0 55 70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_820_243)">
            <path d="M55 2.82226C55 1.26218 53.7422 0 52.1875 0H2.8125C1.25781 0 0 1.26218 0 2.82226C0 4.38235 1.25781 5.64453 2.8125 5.64453H4.50781C4.46094 8.63927 4.72656 11.7046 5.29688 14.6366C6.10156 18.7759 7.45312 22.5232 9.32812 25.7767C11.9688 30.3707 15.9844 33.3184 18.8516 35.1607C15.9922 37.003 11.9688 39.9507 9.32812 44.5447C7.46094 47.7982 6.10156 51.5534 5.29688 55.6848C4.75 58.5149 4.47656 61.4626 4.5 64.3555H2.8125C1.25781 64.3555 0 65.6177 0 67.1777C0 68.7378 1.25781 70 2.8125 70H52.1875C53.7422 70 55 68.7378 55 67.1777C55 65.6177 53.7422 64.3555 52.1875 64.3555H50.5156C50.5391 61.4626 50.2734 58.5149 49.7188 55.6848C48.9141 51.5455 47.5625 47.7982 45.6875 44.5447C43.0469 39.9507 39.0312 37.003 36.1641 35.1607C39.0234 33.3184 43.0469 30.3707 45.6875 25.7767C47.5547 22.5232 48.9141 18.7681 49.7188 14.6366C50.2891 11.7046 50.5547 8.63927 50.5078 5.64453H52.1875C53.7422 5.64453 55 4.38235 55 2.82226ZM40.8203 22.9623C39.2422 25.7061 36.7578 28.1051 32.9922 30.504C31.3906 31.5231 30.4375 33.2635 30.4375 35.1607C30.4375 37.0579 31.3906 38.7983 32.9922 39.8174C36.7578 42.2242 39.2422 44.6153 40.8203 47.3592C43.4844 52.0002 44.9531 58.2092 44.8906 64.3555H10.1328C10.0703 58.2092 11.5391 52.0002 14.2031 47.3592C15.7812 44.6153 18.2656 42.2164 22.0312 39.8174C23.6328 38.7983 24.5859 37.0579 24.5859 35.1607C24.5859 33.2635 23.6328 31.5231 22.0312 30.504C18.2656 28.0972 15.7812 25.7061 14.2031 22.9623C11.4922 18.2428 10.0156 11.8927 10.1328 5.64453H44.8828C45 11.9005 43.5312 18.2428 40.8203 22.9623Z" fill="var(--color-pri)"/>
            <path d="M30.4297 59.5576H24.5781C23.0234 59.5576 21.7656 58.2954 21.7656 56.7354C21.7656 55.1753 23.0234 53.9131 24.5781 53.9131H30.4297C31.9844 53.9131 33.2422 55.1753 33.2422 56.7354C33.2422 58.2876 31.9844 59.5576 30.4297 59.5576Z" fill="var(--color-pri)"/>
            </g>
            <defs>
            <clipPath id="clip0_820_243">
            <rect width="55" height="70" fill="white"/>
            </clipPath>
            </defs>
          </svg>
        </div>
        <div class="line1">伺服器運算中!</div>
        <div class="line2">請稍後再來查看是否運算結果~</div>
        <div class="line3">※可正常操作其他頁面，不影響使用與運算※</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.back {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(94, 94, 94, 0.30);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnc {
  position: absolute;
  top: 9px;
  right: 12px;
  background-color: transparent;
}
.dialog_addnew {
  width: 711px;
  height: 375px;
  margin-inline: auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
  background-color: #FFFFFF;
  position: relative;
  overflow: hidden;
}
.dialog_addnew_title {
  letter-spacing: 0.3em;
  background-color: transparent;
  height: 60px;
  color: #FFFFFF;
  font-weight: 400;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  .closedialog {
    position: absolute;
    right: 7px;
    top: 8px;
    width: 35px;
    height: 35px;
  }
}
.dialog_addnew_content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  .line1 {
    color: var(--color-pri);
    font-family: Noto Sans TC;
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 2px;
    margin-top: 15px;
  }
  .line2 {
    color: var(--color-pri);
    text-align: center;
    font-family: Noto Sans TC;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1.4px;
  }
  .line3 {
    color: var(--highlight);
    font-family: Noto Sans TC;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 1.2px;
    margin-top: 21px;
    margin-bottom: 70px;
  }
}
</style>
